import React, { useEffect, useState } from "react";
import "./ProfileDropdown.scss";
import { selectIcon, SVG } from "../UI/selector";
import { useHistory } from "react-router-dom";
import { getAppNameFromURL } from "../../services/Constants";
import {
  _readNotification,
  clearNotifications,
  listNotifications,
  updateDefaultGym,
} from "../../services/CallApi";
import { ErrorUI } from "../UI/Modals/Modals";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../store";
import { Notification } from "../Notifications/Notification";
import { staticVar } from "../../services/Constants";
const ProfileDropdown = (props) => {
  const history = useHistory();

  return (
    <div
      className="dropdown_content"
      meta-id={props.meta_id}
      onClick={props.closeDropdown}
    >
      <a meta-id={props.meta_id} onClick={() => history.push("/MemberProfile")}>
        <div className="DropDownImageDiv">
          <SVG src={selectIcon("dropdownProfile")} />
        </div>
        <p>Profile</p>
      </a>
      {/* {getAppNameFromURL() == "tribe" ? ( */}
      <a meta-id={props.meta_id} onClick={() => history.push("/Studios")}>
        <div className="DropDownImageDiv">
          <SVG src={selectIcon("dumbell")} />
        </div>
        <p>Studios</p>
      </a>
      {/* ) : null} */}
      <a
        meta-id={props.meta_id}
        onClick={() => history.push("/PrivacySettings")}
      >
        <div className="DropDownImageDiv">
          <SVG src={selectIcon("passwordInput")} />
        </div>
        <p>Privacy Settings</p>
      </a>
      <a
        meta-id={props.meta_id}
        target="_blank"
        href={localStorage.getItem("privacyPolicyLink")}
      >
        <div className="DropDownImageDiv">
          <SVG src={selectIcon("dropdownSetting")} />
        </div>
        <p>Privacy Policy</p>
      </a>
      <a
        meta-id={props.meta_id}
        href={localStorage.getItem("supportLink")}
        target="_blank"
      >
        <div className="DropDownImageDiv">
          <SVG src={selectIcon("contactSupport")} />
        </div>
        <p>Help & Support</p>
      </a>
      <a meta-id={props.meta_id} onClick={props.logout}>
        <div className="DropDownImageDiv">
          <SVG src={selectIcon("logout")} />
        </div>
        <p>Log Out</p>
      </a>
      <div className="appVersion">Version - {staticVar.version}</div>
    </div>
  );
};

export default ProfileDropdown;

export const StudioDropdown = ({ meta_id, closeDropdown, gyms }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const onGymSelect = (gym) => {
    updateDefaultGym(gym.gym_id).then((res) => {
      if (res.status) {
        dispatch(profileActions.updateProfileData(res.data));
      } else {
        ErrorUI(res.list, () => {
          onGymSelect(gym);
        });
      }
    });
  };

  const gymsUI = gyms.map((gym, index) => {
    return (
      <a key={index} meta-id={meta_id} onClick={() => onGymSelect(gym)}>
        <div className="DropDownImageDiv">
          <img src={gym.logo_thumb} height={40} width={40} />
        </div>
        <p>{gym.name}</p>
      </a>
    );
  });

  return (
    <div
      className="dropdown_content studio_dropdown"
      meta-id={meta_id}
      onClick={closeDropdown}
    >
      {gymsUI}
    </div>
  );
};
